<template>
  <div class="upload">
    <div style="width:100%">
      <!-- 已上传图片预览区（多图模式：始终显示已上传的图，不影响继续上传） -->
      <div v-if="type === 'img' && multiple && imgList.length > 0" style="display:flex;flex-wrap:wrap;justify-content:flex-start;margin-bottom:6px;">
        <div
          v-for="(value, key) in imgList"
          :key="key"
          style="position:relative;
          width: 146px;height: 146px;
          overflow: hidden;
          box-shadow:1px 1px 4px rgba(0,0,0,0.1);
          border-radius: 10px;
          margin-bottom:10px;margin-right:10px;
          box-sizing: border-box;"
          class="upload-image"
        >
          <el-image
            style="width: 100%;height: 100%"
            fit="contain"
            :src="value.url"
            :lazy="false"
            alt
          ></el-image>
          <div class="upload-tooltips" style="width:146px;height:146px;">
            <i
              class="el-icon-zoom-in"
              style="color:white;font-size: 20px;"
              @click="handlePictureCardPreview(value)"
            ></i>
            <i
              class="el-icon-delete"
              style="color:white;margin-left:10px;font-size: 20px;"
              @click="handleRemoveByIndex(key)"
            ></i>
          </div>
        </div>
      </div>

      <!-- 单图模式：满了就只显示预览，不显示上传区 -->
      <div v-if="type === 'img' && !multiple && imgList.length >= num" style="display:flex;flex-wrap:wrap;">
        <div
          v-for="(value, key) in imgList"
          :key="key"
          style="position:relative;
          width: 146px;height: 146px;
          overflow: hidden;
          box-shadow:1px 1px 4px rgba(0,0,0,0.1);
          border-radius: 10px;
          margin-bottom:10px;margin-right:10px;
          box-sizing: border-box;"
          class="upload-image"
        >
          <el-image
            style="width: 100%;height: 100%"
            fit="contain"
            :src="value.url"
            :lazy="false"
            alt
          ></el-image>
          <div class="upload-tooltips" style="width:146px;height:146px;">
            <i
              class="el-icon-zoom-in"
              style="color:white;font-size: 20px;"
              @click="handlePictureCardPreview(value)"
            ></i>
            <i
              class="el-icon-delete"
              style="color:white;margin-left:10px;font-size: 20px;"
              @click="handleRemoveByIndex(key)"
            ></i>
          </div>
        </div>
      </div>

      <!-- 视频 -->
      <div style="width:100%;" v-if="type==='video' && imgList.length > 0">
        <video style="width:100%" :src="imgList[0].url" class="video" controls="controls"></video>
        <el-button @click="removeVideo">删除视频</el-button>
      </div>
    </div>

    <!-- 上传区：多图模式下未满就一直显示；单图模式下无图才显示 -->
    <el-upload
      v-if="showUploadArea"
      :action="actionPath"
      list-type="picture-card"
      :data="postData"
      :multiple="multiple"
      :on-remove="handleRemoveFromUploader"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
      :on-preview="handlePictureCardPreview"
      :on-progress="progressUpload"
      :limit="num"
      :file-list="uploaderFileList"
      :accept="accept || '.jpeg, .jpg, .gif, .png, .mp4'"
      ref="uploadImage"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="previewImage" alt/>
    </el-dialog>
  </div>
</template>

<script>
    import {getQiniuToken} from "@/api/public";
    import qiniuUploader from "@/util/qiniuUploader.js";

    export default {
        props: {
            multiple: {
                type: Boolean,
                default: false
            },
            num: {
                type: Number,
                default: 1
            },
            path: {
                type: String,
                default: ""
            },
            images: {
                type: [String, Array],
                default: ""
            },
            accept: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                domain: "https://cdn.puditech.com",
                actionPath: "https://up-z0.qiniup.com",
                dialogVisible: false,
                previewImage: '',
                type: 'img',
                postData: {
                    token: "",
                    key: this.path
                },
                uploadAddr: "https://cdn.puditech.com/",
                // imgList：已确认上传成功（含外部传入的初始图片）
                imgList: [],
                // uploaderFileList：传给 el-upload 的 file-list，多图模式下保持为空让组件自行管理
                uploaderFileList: []
            };
        },
        computed: {
            // 是否显示上传区
            showUploadArea() {
                if (this.type === 'video' && this.imgList.length > 0) return false;
                if (this.multiple) {
                    return this.imgList.length < this.num;
                } else {
                    return this.imgList.length < this.num;
                }
            }
        },
        mounted() {
            getQiniuToken().then((res) => {
                this.postData.token = res.data;
                qiniuUploader.init({
                    region: "CXC",
                    uptoken: res.data,
                    domain: this.domain,
                    shouldUseQiniuFileName: true,
                    key: this.path + "/"
                });
            });
        },
        watch: {
            images: {
                immediate: true,
                deep: true,
                handler(newValue) {
                    if (typeof newValue === 'string') {
                        if (newValue !== '') {
                            if (this.multiple) {
                                // 多图模式：逗号分隔字符串 → 数组
                                var urls = newValue.split(',').filter(function(u) { return u !== ''; });
                                this.imgList = urls.map(function(u) {
                                    return { url: u, status: 'success', percentage: 100 };
                                });
                            } else {
                                this.imgList = [{ url: newValue, status: 'success', percentage: 100 }];
                            }
                            if (newValue.indexOf('.mp4') > -1) {
                                this.type = 'video';
                            } else {
                                this.type = 'img';
                            }
                        } else {
                            this.type = 'img';
                            this.imgList = [];
                        }
                    } else if (Array.isArray(newValue)) {
                        this.type = 'img';
                        this.imgList = newValue.map(function(u) {
                            return { url: u, status: 'success', percentage: 100 };
                        });
                    }
                }
            }
        },
        methods: {
            beforeAvatarUpload(file) {
                this.postData.key = this.path + "/" + this.createNonceStr() + "." + this.suffix(file.name);
            },
            progressUpload() {},
            removeVideo() {
                this.imgList = [];
                this.type = 'img';
                this.$emit('remove', []);
            },
            // el-upload 上传成功回调
            handleAvatarSuccess(res, file, fileList) {
                if (!res || !res.key) return;
                var newUrl = this.uploadAddr + res.key;
                if (res.key.indexOf('.mp4') > -1) {
                    this.type = 'video';
                    this.imgList = [{ url: newUrl, status: 'success', percentage: 100 }];
                    this.$emit('success', [newUrl]);
                } else {
                    this.type = 'img';
                    // 把新上传的图追加到 imgList
                    this.imgList.push({ url: newUrl, status: 'success', percentage: 100 });
                    // 上传完成后清空 el-upload 内部列表（避免重复显示），由我们自己的 imgList 渲染
                    if (this.$refs.uploadImage) {
                        this.$refs.uploadImage.clearFiles();
                    }
                    var images = this.imgList.map(function(item) { return item.url; });
                    this.$emit('success', images);
                }
            },
            // el-upload 内部删除（多图模式下 el-upload 自己管理的文件，一般不触发，留作兜底）
            handleRemoveFromUploader(file, fileList) {
                var images = fileList.map(function(f) { return f.url || (f.response ? 'https://cdn.puditech.com/' + f.response.key : ''); });
                this.$emit('remove', images);
            },
            // 自定义预览区的删除按钮（按索引删除）
            handleRemoveByIndex(index) {
                this.imgList.splice(index, 1);
                var images = this.imgList.map(function(item) { return item.url; });
                this.$emit('remove', images);
            },
            handlePictureCardPreview(file) {
                this.previewImage = file.url;
                this.dialogVisible = true;
            },
            suffix(filename) {
                var index = filename.lastIndexOf(".");
                return filename.substr(index + 1);
            },
            createNonceStr() {
                var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
                var res = "";
                for (var i = 0; i < 16; i++) {
                    res += chars[Math.floor(Math.random() * chars.length)];
                }
                return res;
            }
        }
    };
</script>

<style lang="scss">
  .upload {
    // width: 370px;
  }

  .uoloadSty {
    display: block;
  }

  .disUoloadSty {
    display: none;
  }

  .upload-tooltips {
    display: none;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 6px;
    color: white;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.5);
    justify-content: center;
    align-items: center;
  }

  .upload-image:hover {
    .upload-tooltips {
      display: inline-flex;
    }
  }
</style>
